/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Type_Picker_DescriptionInputs */

const en_case_type_picker_description = /** @type {(inputs: Case_Type_Picker_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the case type to enable document upload.`)
};

const pt_br2_case_type_picker_description = /** @type {(inputs: Case_Type_Picker_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o tipo de caso para habilitar o envio de documentos.`)
};

/**
* | output |
* | --- |
* | "Select the case type to enable document upload." |
*
* @param {Case_Type_Picker_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_picker_description = /** @type {((inputs?: Case_Type_Picker_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_Picker_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_picker_description(inputs)
	return pt_br2_case_type_picker_description(inputs)
});